
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'PancreaticCancer_TNM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/PancreaticCancer_TNM.vue